(function () {

    'use strict';

    angular.module('iplusjs.utils.misc', [
        'lodash',
        'moment',
        'iplusjs.config',
        'iplusjs.utils.identityType',
        'iplusjs.utils.money',
        'iplusjs.utils.schluesselWerte',
        'iplusjs.integration',
        'iplusjs.utils.device'
    ])
        .service('MiscUtilsService', MiscUtilsService);

    MiscUtilsService.$inject = [
        '$q',
        '$injector',
        '$window',
        'lodash',
        'moment',
        'AppConfig'
    ];
    function MiscUtilsService($q, $injector, $window, _, moment, AppConfig) {
        var that = this,
            browserPlugins = {
                AdobeAcrobat: {
                    name: ['Adobe Acrobat'],
                    progIds: ['AcroPDF.PDF', 'PDF.PDFCtrl.5']
                }
            },
            linkEl;

        that.isEmpty = isEmpty;
        that.isNotEmpty = isNotEmpty;
        that.isEverythingEmpty = isEverythingEmpty;
        that.isEverythingNotEmpty = isEverythingNotEmpty;
        that.isAtLeastOneEmpty = isAtLeastOneEmpty;
        that.isAtLeastOneNotEmpty = isAtLeastOneNotEmpty;
        that.isEverythingTrueOrFalse = isEverythingTrueOrFalse;
        that.isAtLeastOneTrueOrFalse = isAtLeastOneTrueOrFalse;
        that.isAtLeastOneTrue = isAtLeastOneTrue;
        that.getDefaultValueIfEmpty = getDefaultValueIfEmpty;
        that.setDefaultValueIfEmpty = setDefaultValueIfEmpty;
        that.setValue = setValue;
        that.setValuesToNull = setValuesToNull;
        that.filterArray = filterArray;
        that.getValuesAsObject = getValuesAsObject;
        that.getValuesByProperty = getValuesByProperty;
        that.getValueCustomObject = getValueCustomObject;
        that.clearObject = clearObject;
        that.removeProperty = removeProperty;
        that.isEqual = isEqual;
        that.existsBrowserPlugin = existsBrowserPlugin;
        that.existsAdobeAcrobatPlugin = existsAdobeAcrobatPlugin;
        that.guid = guid;
        that.isGreaterThan = isGreaterThan;
        that.isLowerThan = isLowerThan;
        that.includesMultiSome = includesMultiSome;
        that.includesMultiEvery = includesMultiEvery;
        that.mergeUniq = mergeUniq;
        that.getPropertyKeysByEgExp = getPropertyKeysByEgExp;
        that.numberComparator = numberComparator;
        that.getAbsoluteUrl = getAbsoluteUrl;
        that.checkFilterCondition = checkFilterCondition;
        that.isAppModus = isAppModus;
        that.isPdfjsViewerEnabled = isPdfjsViewerEnabled;
        that.hashMessage = hashMessage;
        function isEmpty(value) {
            if (typeof value === 'function' || value instanceof Date) {
                return _.isUndefined(value);
            } else if ((_.isNumber(value) && !_.isNaN(value)) || _.isBoolean(value) || _.isRegExp(value)) {
                return false;
            } else {
                return _.isEmpty(value);
            }
        }
        function isNotEmpty(value) {
            return !isEmpty(value);
        }
        function isEverythingEmpty() {
            var values = Array.prototype.slice.call(arguments),
                idx,
                len;

            for (idx = 0, len = values.length; idx < len; idx++) {
                if (!isEmpty(values[idx])) {
                    return false;
                }
            }

            return true;
        }
        function isEverythingNotEmpty() {
            var values = Array.prototype.slice.call(arguments),
                idx,
                len;

            if (!values.length) {
                return false;
            }

            for (idx = 0, len = values.length; idx < len; idx++) {
                if (isEmpty(values[idx])) {
                    return false;
                }
            }

            return true;
        }
        function isAtLeastOneEmpty() {
            var values = Array.prototype.slice.call(arguments),
                idx,
                len;

            if (!values.length) {
                return true;
            }

            if (values.length === 1 && _.isArray(values[0])) {
                values = Array.prototype.slice.call(values[0]);
            }

            for (idx = 0, len = values.length; idx < len; idx++) {
                if (isEmpty(values[idx])) {
                    return true;
                }
            }

            return false;
        }
        function isAtLeastOneNotEmpty() {
            var values = Array.prototype.slice.call(arguments),
                idx, len;

            if (values.length === 1 && _.isArray(values[0])) {
                values = Array.prototype.slice.call(values[0]);
            }

            for (idx = 0, len = values.length; idx < len; idx++) {
                if (!isEmpty(values[idx])) {
                    return true;
                }
            }

            return false;
        }
        function isEverythingTrueOrFalse(values, trueOrFalse) {
            if (isEmpty(values) || !_.isArray(values) || isEmpty(trueOrFalse)) {
                return false;
            }

            return values.every(function (value) {
                return _.isBoolean(value) && (value === trueOrFalse || (_.isFunction(value.valueOf) && value.valueOf() === trueOrFalse));
            });
        }
        function isAtLeastOneTrueOrFalse(values, trueOrFalse) {
            if (isEmpty(values) || !_.isArray(values) || isEmpty(trueOrFalse)) {
                return false;
            }

            return values.some(function (value) {
                return _.isBoolean(value) && (value === trueOrFalse || (_.isFunction(value.valueOf) && value.valueOf() === trueOrFalse));
            });
        }
        function isAtLeastOneTrue() {
            var values = Array.prototype.slice.call(arguments);

            if (values.length === 1 && _.isArray(values[0])) {
                values = Array.prototype.slice.call(values[0]);
            }

            if (isEmpty(values) || !_.isArray(values)) {
                return false;
            }

            return values.some(function (value) {
                return _.isBoolean(value) && (value === true || (_.isFunction(value.valueOf) && value.valueOf()));
            });
        }
        function getDefaultValueIfEmpty(value, defaultValue) {
            return isEmpty(value) ? defaultValue : value;
        }
        function setDefaultValueIfEmpty(obj, path, defaultValue) {
            var value = getDefaultValueIfEmpty(_.get(obj, path), defaultValue);

            _.set(obj, path, value);
        }
        function setValue(obj, path, value) {
            if (isAtLeastOneEmpty(obj, path)) {
                return;
            }

            _.set(obj, path, value);
        }
        function setValuesToNull(obj, paths) {
            if (isAtLeastOneEmpty(obj, paths)) {
                return;
            }

            _.each(_.isString(paths) ? [paths] : paths, function (path) {
                setValue(obj, path, null);
            });
        }
        function filterArray(array, allowedValues, compareProperty, sortByAllowedValues) {
            var filteredArray = _.filter(array, function (value) {
                return _.includes(allowedValues, compareProperty ? _.get(value, compareProperty) : value);
            });

            return sortByAllowedValues ? _.sortBy(filteredArray, [function (value) {
                return _.indexOf(allowedValues, compareProperty ? _.get(value, compareProperty) : value);
            }]) : filteredArray;
        }
        function getValuesAsObject(value, props) {
            if (_.isArray(value)) {
                return _.zipObject(props, value);
            } else if (_.isObject(value)) {
                return _.pick(value, props);
            }

            return {};
        }
        function getValuesByProperty(values, property) {
            if (!_.isString(property) || _.isEmpty(property)) {
                return [];
            }

            return _.map(values, function (item) {
                return _.get(item, property);
            });
        }
        function getValueCustomObject(value) {
            var IdentityTypeUtilsService = $injector.get('IdentityTypeUtilsService'),
                MoneyUtilsService = $injector.get('MoneyUtilsService'),
                SchluesselWerteUtilsService = $injector.get('SchluesselWerteUtilsService');

            if (IdentityTypeUtilsService.isIdentityType(value)) {
                return _.get(value, 'id');
            } else if (MoneyUtilsService.isMoneyObject(value)) {
                return MoneyUtilsService.getAmount(value);
            } else if (
                SchluesselWerteUtilsService.isSchluesselWert(value) ||
                _.every(['wert', 'bezeichnung'], _.partial(_.has, value)) ||
                _.every(['art', 'wert', 'kommunikationswegId'], _.partial(_.has, value)) // Kommunikationsmedium (muss min. die Properties art, wert und kommunikationswegId haben)
            ) {
                return _.get(value, 'wert');
            } else if (_.includes(['SELBSTBETEILIGUNGSCODE', 'LEISTUNGSGRENZENCODE'], _.get(value, 'code.type'))) {
                return _.get(value, 'code.id');
            } else if (_.includes(['SCHADENFREIHEITSKLASSEHUKID'], _.get(value, 'id.type'))) {
                return _.get(value, 'klasse');
            }

            return value;
        }
        function clearObject(obj, ignoreProperties, deep) {
            _.forOwn(obj, function (value, key) {
                if (_.includes(ignoreProperties, key)) {
                    return;
                }

                if (_.isPlainObject(value)) {
                    if (deep) {
                        clearObject(value, ignoreProperties, deep);
                    } else {
                        obj[key] = null;
                    }
                } else {
                    obj[key] = _.isArray(value) ? [] : null;
                }
            });
        }
        function removeProperty(obj, prop, deep) {
            if (!obj || !_.isObject(obj) || isEmpty(prop)) {
                return;
            }

            delete _.unset(obj, prop);

            if (!deep) {
                return;
            }

            _.forEach(_.keysIn(obj), function (key) {
                if (_.isPlainObject(obj[key])) {
                    removeProperty(obj[key], prop, deep);
                } else if (_.isArray(obj[key])) {
                    _.forEach(obj[key], function (el) {
                        removeProperty(el, prop, deep);
                    });
                }
            });
        }
        function isEqual(value1, value2, ignoreCase) {
            var val1 = value1,
                val2 = value2;

            if (_.isString(val1) && ignoreCase) {
                val1 = _.toLower(val1);
            }

            if (_.isString(val2) && ignoreCase) {
                val2 = _.toLower(val2);
            }

            return _.isEqual(val1, val2);
        }
        function existsBrowserPlugin(pluginName) {
            var browserPlugin = browserPlugins[pluginName] || {
                    name: [pluginName],
                    progIds: [pluginName]
                },
                pluginFound = false,
                plugins = [];

            if ($window.ActiveXObject) {
                _.forEach(browserPlugin.progIds, function (pluginProgId) {
                    try {
                        pluginFound = !!(new $window.ActiveXObject(pluginProgId));
                    } catch (e) {
                        pluginFound = false;
                    }

                    if (pluginFound) {
                        return false;
                    }
                });
            } else if ($window.navigator.plugins) {
                plugins = $window.navigator.plugins;
                _.forEach(browserPlugin.name, function (pluginName) {

                    pluginFound = _.findIndex(plugins, {
                        name: pluginName
                    }) > -1 ? true : false;

                    if (pluginFound) {
                        return false;
                    }
                });
            }

            return pluginFound;
        }
        function existsAdobeAcrobatPlugin() {
            return existsBrowserPlugin('AdobeAcrobat');
        }
        function guid(pattern) {
            function s4() {
                return $window.Math.floor((1 + $window.Math.random()) * 0x10000).toString(16).substring(1);
            }

            pattern = pattern || '##-#-#-#-###';

            if (pattern === '##-#-#-#-###' && _.isFunction(_.get(self, 'crypto.randomUUID'))) {
                return self.crypto.randomUUID();
            }

            return _.map(_.split(pattern, ''), function (val) {
                return val === '#' ? s4() : val;
            }).join('');
        }
        function isGreaterThan(value, compareValue, options) {
            options = options || {};

            var dateFormat = options.dateFormat || AppConfig.API.dateFormat || 'YYYY-MM-DD',
                momentValue,
                momentCompareValue,
                numberValue,
                numberCompareValue;

            if (isEmpty(value) || isEmpty(compareValue)) {
                return true;
            }

            momentValue = _.isDate(value) ? moment(value) : moment(value, dateFormat, true);
            momentCompareValue = _.isDate(compareValue) ? moment(compareValue) : moment(compareValue, dateFormat, true);

            if (momentValue.isValid() && momentCompareValue.isValid()) {
                return momentValue[options.equalAllowed ? 'isSameOrAfter' : 'isAfter'](momentCompareValue, options.byYear ? 'year' : null);

            } else {
                numberValue = _.toNumber(value);
                numberCompareValue = _.toNumber(compareValue);

                return (options.equalAllowed ? numberValue >= numberCompareValue : numberValue > numberCompareValue);
            }
        }
        function isLowerThan(value, compareValue, options) {
            options = options || {};

            var dateFormat = options.dateFormat || AppConfig.API.dateFormat || 'YYYY-MM-DD',
                momentValue,
                momentCompareValue,
                numberValue,
                numberCompareValue;

            if (isEmpty(value) || isEmpty(compareValue)) {
                return true;
            }

            momentValue = _.isDate(value) ? moment(value) : moment(value, dateFormat, true);
            momentCompareValue = _.isDate(compareValue) ? moment(compareValue) : moment(compareValue, dateFormat, true);

            if (momentValue.isValid() && momentCompareValue.isValid()) {
                return momentValue[options.equalAllowed ? 'isSameOrBefore' : 'isBefore'](momentCompareValue, options.byYear ? 'year' : null);

            } else {
                numberValue = _.toNumber(value);
                numberCompareValue = _.toNumber(compareValue);

                return (options.equalAllowed ? numberValue <= numberCompareValue : numberValue < numberCompareValue);
            }
        }
        function includesMultiSome(values, multiCompareValues) {
            return _.some(multiCompareValues, function (compareValue) {
                return _.includes(values, compareValue);
            });
        }
        function includesMultiEvery(values, multiCompareValues) {
            return _.every(multiCompareValues, function (compareValue) {
                return _.includes(values, compareValue);
            });
        }
        function mergeUniq(base, source, uniqByPropPath) {
            if (isEmpty(source)) {
                return base;
            }

            return _.uniqBy(_.concat(base, source), uniqByPropPath);
        }
        function getPropertyKeysByEgExp(obj, regExp) {
            return _.filter(_.keys(obj), function (key) {
                return (key.match(regExp) || []).length > 0;
            });
        }
        function numberComparator(value1, value2) {
            if (isNaN(parseFloat(value1.value)) || isNaN(parseFloat(value2.value))) {
                if (value1.type !== 'string' || value2.type !== 'string') {
                    return (value1.index < value2.index) ? -1 : 1;
                }
                return value1.value.localeCompare(value2.value);
            }

            return parseFloat(value1.value) < parseFloat(value2.value) ? -1 : (parseFloat(value1.value) > parseFloat(value2.value) ? 1 : 0);
        }

        function getAbsoluteUrl(url) {
            if (!linkEl) {
                linkEl = $window.document.createElement('a');
            }

            linkEl.href = url;

            return linkEl.href;
        }
        function checkFilterCondition(filterCondition, filterVal) {
            var returnVal = false,
                betweenCondtion,
                filterConditionSplitted;

            filterCondition = filterCondition || '';

            function getBetweenCondition(condition) {
                return (condition.match(/.+([<|>]+=?.*)/) || [])[1];
            }

            if (isEmpty(filterVal)) {
                return false;
            }

            if (_.startsWith(filterCondition, '>=')) {
                filterConditionSplitted = (filterCondition.substring(2) || '').match(/(^[\d.]*)(.*)/);

                if (parseFloat(filterVal) >= parseFloat(filterConditionSplitted[1])) {
                    betweenCondtion = getBetweenCondition(filterConditionSplitted[0]);
                    if (betweenCondtion) {
                        if (checkFilterCondition(betweenCondtion, filterVal)) {
                            returnVal = true;
                        }
                    } else {
                        returnVal = true;
                    }

                }
            } else if (_.startsWith(filterCondition, '<=')) {
                filterConditionSplitted = (filterCondition.substring(2) || '').match(/(^[\d.]*)(.*)/);

                if (parseFloat(filterVal) <= parseFloat(filterConditionSplitted[1])) {
                    betweenCondtion = getBetweenCondition(filterConditionSplitted[0]);
                    if (betweenCondtion) {
                        if (checkFilterCondition(betweenCondtion, filterVal)) {
                            returnVal = true;
                        }
                    } else {
                        returnVal = true;
                    }
                }
            } else if (_.startsWith(filterCondition, '>')) {
                filterConditionSplitted = (filterCondition.substring(1) || '').match(/(^[\d.]*)(.*)/);

                if (parseFloat(filterVal) > parseFloat(filterConditionSplitted[1])) {
                    betweenCondtion = getBetweenCondition(filterConditionSplitted[0]);
                    if (betweenCondtion) {
                        if (checkFilterCondition(betweenCondtion, filterVal)) {
                            returnVal = true;
                        }
                    } else {
                        returnVal = true;
                    }
                }
            } else if (_.startsWith(filterCondition, '<')) {
                filterConditionSplitted = (filterCondition.substring(1) || '').match(/(^[\d.]*)(.*)/);

                if (parseFloat(filterVal) < parseFloat(filterConditionSplitted[1])) {
                    betweenCondtion = getBetweenCondition(filterConditionSplitted[0]);
                    if (betweenCondtion) {
                        if (checkFilterCondition(betweenCondtion, filterVal)) {
                            returnVal = true;
                        }
                    } else {
                        returnVal = true;
                    }
                }
            } else if (filterCondition == filterVal) { // eslint-disable-line eqeqeq
                returnVal = true;
            } else if (filterCondition.indexOf(',') > -1) {
                if (_.some(_.map(_.split(filterCondition, ','), _.trim), function (val) {
                    return val == filterVal; // eslint-disable-line eqeqeq
                })) {
                    returnVal = true;
                }
            } else if (filterCondition === '*') {
                returnVal = true;
            }

            return returnVal;
        }

        function isAppModus() {
            var IntegrationService = $injector.get('IntegrationService');

            return (
                !!_.get($window, 'webkit.messageHandlers.cordova_iab.postMessage') ||
                !!IntegrationService.getIntegrationParams().appModus
            );
        }

        function isPdfjsViewerEnabled() {
            var DeviceUtilsService = $injector.get('DeviceUtilsService');

            if (DeviceUtilsService.isMSIE()) {
                return false;
            }

            if (AppConfig.APP.pdfModus === 'native') {
                return false;
            } else if (AppConfig.APP.pdfModus === 'dynamic') {
                return isAppModus();
            } else if (AppConfig.APP.pdfModus === 'pdfjs') {
                return true;
            }
        }

        function hashMessage(message, algorithm) {
            return $q(function (resolve, reject) {
                if (!($window.TextEncoder && $window.TextEncoder.prototype.encode) ||
                    !('Uint8Array' in $window) ||
                    !_.includes([
                        'SHA-1',
                        'SHA-256',
                        'SHA-384',
                        'SHA-512'
                    ], algorithm)
                ) {
                    return reject('NOT_SUPPORTED');
                }

                if (!message) {
                    return resolve(null);
                }

                var msgUint8,
                    hashArray,
                    hashHex;

                msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
                crypto.subtle.digest(algorithm, msgUint8).then(function (hashBuffer) {
                    hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
                    hashHex = hashArray.map(function (b) {
                        return b.toString(16).padStart(2, '0'); // convert bytes to hex string
                    }).join('');
                    return resolve(hashHex);
                });
            });
        }
    }

})();
